(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("Yasgui", [], factory);
	else if(typeof exports === 'object')
		exports["Yasgui"] = factory();
	else
		root["Yasgui"] = factory();
})(window, function() {
return 